import React, { useMemo } from 'react';
import { Popover } from '@stereoagency/ui';
import { useCallToActions, useMediaItems } from '@/hooks';
import { ILazyBlocksImage } from '@/types';


type Props = {
  data: {
    title: string
    text?: string
    callToActions?: number[]
    image?: ILazyBlocksImage
  }
};

export default function NvisoPopoverBanner({ data: { title, text, callToActions, image } }: Props) {
  const paragraph = text ?? '';
  const callToActionObjects = useCallToActions(callToActions ?? [], false);
  const mediaItems = useMediaItems(useMemo(() => (image ? [image.id] : []), [image]));
  const imageProps = useMemo(() => {
    const mediaItem = image ? mediaItems.get(image.id) : null;
    if (!mediaItem || !image) return null;
    return {
      src: mediaItem?.mediaItemUrl ?? image.url ?? '',
      width: mediaItem?.mediaDetails?.width ?? 330,
      height: mediaItem?.mediaDetails?.height ?? 120,
      sizes: '100vw',
    };
  }, [image, mediaItems]);
  return (
    <Popover
      title={title}
      text={paragraph}
      callToActions={callToActionObjects}
      image={imageProps ?? undefined}
    />
  );
}
